import React from 'react';
import { Reveal } from './Reveal';
type Bonus = {
  number: string;
  title: string;
  subtitle: string;
  description: string;
};
const bonuses: Bonus[] = [{
  number: 'BONUS 01',
  title: 'Pre-Session Preparation & Grounding Rituals',
  subtitle: 'Centering Protocols for Clinical Integrity',
  description: 'Neuroscience of grounding, 5-minute pre-session reset, 15-minute deep centering practice, energetic clearing protocol, boundary setting ritual, space preparation protocol, emotional release practice, intention setting practice, protective protocols, post-session clearing practice, and audio guided versions with QR codes.'
}, {
  number: 'BONUS 02',
  title: 'Astrological Foundations & Lunar Cycles',
  subtitle: 'Understanding Planetary Influences',
  description: 'The psychological zodiac (all 12 signs with shadow and gifts), the 10 planets & psychological meanings, moon cycles & emotional landscape (8 phases), new moon intention setting practice, full moon release ritual, mercury retrograde navigation, planetary return cycles, basic synastry overview, and astrology integration guide.'
}, {
  number: 'BONUS 03',
  title: 'Inner Frequency & Resonance Mastery',
  subtitle: 'Elevating Your Vibrational State',
  description: 'Physics of frequency, vibrational scale of consciousness (Hawkins calibrated scale), 10 frequency elevation practices, frequency assessment protocol, the resonance principle, frequency anchoring techniques, frequency contagion effect, frequency protection protocols, frequency matching & pacing, and daily/weekly/monthly advanced practices.'
}, {
  number: 'BONUS 04',
  title: 'Energetic Protection & Boundary Mastery',
  subtitle: 'Advanced Protocols for Professional Sustainability',
  description: 'Anatomy of energetic boundaries, 5 levels of boundary setting (physical, emotional, mental, energetic, spiritual), 7 shielding visualizations, auric reinforcement techniques, psychic self-defense protocols, advanced grounding & rooting mastery, cord cutting & release protocol, difficult client navigation, boundary communication scripts, and post-session contamination clearing.'
}, {
  number: 'BONUS 05',
  title: 'Professional Ethics & Scope of Practice',
  subtitle: 'Clinical Standards, Legal Considerations & Ethical Guidelines',
  description: 'Scope of practice definition, distinction between tarot and therapy, legal landscape guidance, confidentiality obligation, informed consent standard, mandated reporting requirements, ethical issues around predictions, vulnerable population protocols, financial ethics, and dual relationship risks.'
}];
export function Bonuses() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-17" data-mp="37lein0ewt6bo">
      <div className="mx-auto max-w-6xl" data-id="element-18" data-mp="2a57kgoeybkk8">
        <Reveal className="text-center" data-id="element-19" data-mp="2a460tvjvdpqw">
          <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-20" data-mp="2f30q9gccecjz">
            🎁 5 Exclusive <span className="text-amber" data-id="element-21" data-mp="27kjet4kwonod">Bonus Resource Kits</span>
          </h2>
          <p className="mt-4 text-sm text-slate sm:text-base" data-id="element-22" data-mp="22kwz8ohluvce">Included FREE with your purchase</p>
        </Reveal>
        <div className="mt-10 flex flex-col items-center gap-4" data-id="element-23" data-mp="1xlk65m054s1d">
          {bonuses.map((bonus, index) => <Reveal key={bonus.number} delay={index * 0.04} className="w-full max-w-3xl" data-id="element-24" data-mp="1tl05w9k9t8b0" data-mpi={index}>
              <article className="rounded-2xl border border-amber/50 bg-mist p-7 shadow-premium sm:p-9" data-id="element-25" data-mp="1olnkzucymbb2">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-26" data-mp="1ju5j943446p1">
                  <span className="rounded-full bg-amber-pale px-3 py-1 text-[11px] font-bold uppercase tracking-[0.15em] text-navy" data-id="element-27" data-mp="1ev2p4eoo7kvu">
                    {bonus.number}
                  </span>
                  <span className="text-xs font-bold uppercase tracking-[0.12em] text-sage" data-id="element-28" data-mp="15unzx48l5ln2">
                    FREE
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-2xl leading-tight text-navy sm:text-3xl" data-id="element-29" data-mp="10wcs0z1upl7h">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-sm font-semibold text-amber" data-id="element-30" data-mp="34z5w1he2cb8c">{bonus.subtitle}</p>
                <p className="mt-4 text-sm leading-7 text-slate" data-id="element-31" data-mp="2r898i4yzuk85">{bonus.description}</p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}